module.exports = __webpack_public_path__ + "static/media/got.b3132cdd.png";